module.exports = __webpack_public_path__ + "static/media/bible.6939f5c9.svg";